// Authenticated-user context, split out of App.tsx so pages can import
// `useMe` without depending on App.tsx (which in turn imports every
// page — the old mid-file `export` there was a circular-ish footgun).
import { createContext, useContext } from 'react';
import type { Me } from './api/types';

export const MeContext = createContext<Me | null>(null);

export function useMe(): Me {
  const m = useContext(MeContext);
  if (!m) throw new Error('useMe outside Authed');
  return m;
}
